import React from 'react';
import cn from '../../../../lib/bem';
import ico_documento from './../../../../assets/icons/ico_documento.svg';
import ButtonComponent from '../../../../components/button/button_component';
import HeaderComponent from '../../../../components/header/header_component';
import {CONTENT_PAG} from '../../constants/content_pag';

import './consideracionesCR.scss';

const ConsideracionesCR = ({mostrarPagConsultaRescate}) => {
  
    const classes = cn("consideracionesCR");

    const onClickAcpetar = () => {
        mostrarPagConsultaRescate(CONTENT_PAG.PAG_LAYO);
    }

    return (
        <div className={classes()}>
            <HeaderComponent flagHeaderMobile={false} index={false} title={"Consulta de Rescate"}/>
            <div className={classes('consuRescaConsideracionesDiv')}>
                
                <div>
                    <img src={ico_documento} alt='cobrar' />
                </div>
                <br/>
                <div>
                    <p><b>Consideraciones</b></p>
                </div>
                <div className={classes('consuRescaConsideracionesList')}>
                    <ol>
                        <li>
                            Recuerda que para solicitar el rescate tú debes ser el titular de la cuenta, no debe ser mancomunada y estar en la moneda de su póliza. 
                        </li>
                        <li>
                            Ten presente que el rescate total de tu póliza implica su resolución y, por lo tanto, la culminación de todas las coberturas brindadas a través de la misma y la pérdida del beneficio de devolución de prima
                        </li>
                        <li>
                            Es importante que tengas en cuenta la fecha en la que puedes solicitar el rescate, la cual se encuentra mencionada en tu póliza. 
                        </li>
                        <li>
                            El monto de rescate considera la devolución del seguro de vida. Ej: Si pagaste un seguro de vida y solicitas la resolución al mes 5, se te devolverá la prima por los 7 meses restantes).
                        </li>
                        <li>
                            Es importante que escribas correctamente tu número de cuenta bancaria para culminar satisfactoriamente el proceso. 
                        </li>
                        <li>
                            Para cuentas bancarias diferente al BCP, BBVA, Scotiabank e Interbank, deberás adjuntar una foto o captura del voucher con el nombre del titular. 
                        </li>
                    </ol>
                </div>
                <br/>
                <div className={classes('consuRescaConsideracionesButton')}>
                    <ButtonComponent label={'btnAceptar'} nombre={ 'Aceptar' } tipo={'button-red'} action={() => onClickAcpetar()} disabled={false}/>
                </div>
                <br/>
            </div>
        </div>
    );
}



export default ConsideracionesCR;
